import { Action } from '@ngrx/store';

import { CitationsByItem } from '®shared/reading-list/models';

export interface CitationStyleChangedPayload {
  styleId: string;
}

export enum CitationActionTypes {
  CITATION_STYLE_CHANGED = '[Citations] citation style changed',
  CITATIONS_LOADED = '[Citations] citations loaded',
}

export class CitationStyleChangedAction implements Action {
  readonly type = CitationActionTypes.CITATION_STYLE_CHANGED;

  constructor(public payload: CitationStyleChangedPayload) {}
}

export class CitationsLoadedAction implements Action {
  readonly type = CitationActionTypes.CITATIONS_LOADED;

  constructor(public payload: CitationsByItem) {}
}

export type CitationActions =
  | CitationStyleChangedAction
  | CitationsLoadedAction;
